document.addEventListener("DOMContentLoaded", function () {
  const iconHamburger = document.querySelector("header .icon-hamburger");
  const iconClose = document.querySelector("header .icon-close");
  const mobileMenu = document.querySelector("header .menu-wrapper");

  if (!mobileMenu) return;

  if (iconHamburger) {
    iconHamburger.addEventListener("click", () => {
      if (!mobileMenu.classList.contains("active")) {
        mobileMenu.classList.add("active");
      }
    });
  }

  if (iconClose) {
    iconClose.addEventListener("click", () => {
      if (mobileMenu.classList.contains("active")) {
        mobileMenu.classList.remove("active");
      }
    });
  }
});
